/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, Fragment } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import NewPagination from 'components/NewPagination';
import Section from 'components/Section';
import SearchInput from 'components/SearchInput';
import Checkbox from 'components/Checkbox';

import { Spinner, InputText } from 'triider-components';

import { getServicesByCompany, apiGetTasksFilters } from 'services/api/task';
import { getUsersByCompany } from 'services/api/users';
import { getLabels } from 'services/api/labels';

import moment from 'moment';
import searchFailIcon from 'assets/img/search-fail.svg';

import { Creators as TaskCreators } from 'store/ducks/task';
import { Creators as RespCreators } from 'store/ducks/companyResponsibility';
import { OptionLocal } from 'config/tasksFilters';
import { routes } from 'config/routes';
import statusDone from 'assets/img/statusDone.svg';
import ModalFilter from 'components/ModalFilter';
import RadioGroup from 'components/RadioGroup';

import * as locales from 'react-date-range/dist/locale';
import { DateRange } from 'react-date-range';
import SEGMENTS from '../../helpers/segment';

import FilterStatusTabs from '../../components/FilterStatus';
import Row from './Row';
import Labels from './Labels';

import {
  Container,
  ListWrapper,
  List,
  ContentFilters,
  Label,
  SearchFail,
  Loader,
  ColumnFilters,
  SelectStyled,
  FiltersHeader,
  ContentFooterButtons,
  ButtonFooter,
  BtnMoreFilters2,
  ContentPagination,
  StatusTitleList,
  ContentRadio,
  ShowTasksManaging,
} from './styles';

const TaskList = ({
  tasks,
  total,
  tabsStatus,
  userId,
  rolesRespFilter,
  _getResponsibilities,
  _getTabsStatus,
  offsetActiveFilter,
  _getTasksFilter,
  statusActived,
  _listFiltersRedux,
  _setListFiltersRedux,
  _isAdvancedSearchRedux,
  _push,
  company_id,
  location,
  loadingVisible,
  optionsFilters,
  segment_id,
}) => {
  const initialState = [{ query: 'operator_id', value: '' }, { query: 'order', value: 'last_created' }, { query: 'address_id', value: '' }, { query: 'rangeDate', value: '' }, { query: 'hiredDate', value: '' }, { query: 'chargedDate', value: '' }, { query: 'quotes', value: '' }, { query: 'charged', value: '' }, { query: 'hired', value: '' }, { query: 'service_id', value: '' }, { query: 'created', value: '' }, { query: 'filterTaskVisit', value: '' }, { query: 'label', value: [] }];
  const [listFilters, setListFilters] = useState(
    location.ofBack ? _listFiltersRedux
      : initialState,
  );
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const [dateQueryChecked, setDateQueryChecked] = useState('rangeDate');
  const [dateFilter, setDateFilter] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ]);
  const [isAdvancedSearch, setAdvancedSearch] = useState(
    location.ofBack ? _isAdvancedSearchRedux : false,
  );
  const [optionsLocal, setOptionsLocal] = useState([]);
  const [localTerm, setLocalTerm] = useState(
    location.ofBack && listFilters.find(f => f.query === 'address_id')
      ? listFilters.find(f => f.query === 'address_id').value
      : '',
  );
  const [searchTerm, setSearchTerm] = useState(
    location.ofBack && listFilters.find(f => f.query === 'term')
      ? listFilters.find(f => f.query === 'term').value
      : '',
  );
  const [fetchFilter, setFetchFilter] = useState(0);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [sizeModalApplied, setSizeModalApplied] = useState(0);
  const [optionsFilterDate, setOptionsFilterDate] = useState([{ value: 'rangeDate', label: 'Data de abertura do pedido' }]);
  const [userFilterOptions, setUserFilterOptions] = useState([]);
  const [labels, setLabels] = useState([]);
  const IMOB_SEGMENT = segment_id === SEGMENTS.IMOBILIARIA || segment_id === null;

  const setSizeFiltersModalApplied = () => {
    const listApplied = listFilters.filter(f => f.value !== ''
      && (f.query === 'address_id'
      || f.query === 'hired'
      || f.query === 'operator_id'
      || f.query === 'created'
      || f.query === 'service_id'
      || f.query === 'quotes'
      || f.query === 'charged'
      || f.query === 'rangeDate'
      || f.query === 'hiredDate'
      || f.query === 'filterTaskVisit'
      || f.query === 'chargedDate'));

    setSizeModalApplied(listApplied.length);
  };

  const capitalize = word => word[0].toUpperCase() + word.substr(1).toLowerCase();

  const getServicesAPI = async () => {
    const data = await getServicesByCompany(company_id);
    if (data.success && data.services) {
      const newServiceOptions = [];
      newServiceOptions.push({ value: '', label: 'Todos' });
      await data.services.forEach((service) => {
        newServiceOptions.push({ value: service.id, label: service.text });
      });
      setServiceOptions(newServiceOptions);
    }
  };

  const getUsersByCompanyAPI = async () => {
    const data = await getUsersByCompany(company_id, 'limit=999&order=name');
    if (data.success && data.users) {
      const newUserOptions = [];
      newUserOptions.push({ value: '', label: 'Todos' });
      newUserOptions.push({ value: 'null', label: 'Não atribuídos' });
      await data.users.forEach((user) => {
        newUserOptions.push({ value: user.id, label: user.name });
      });
      setUserFilterOptions(newUserOptions);
    }
  };

  const getLabelsFilter = async () => {
    const data = await getLabels();
    if (data.success) {
      setLabels(data.labels);
    }
  };

  const getLocalsAPI = async () => {
    const data = await apiGetTasksFilters('addresses', company_id, `${localTerm}&offset=0`);
    if (data) {
      const newAddressesOptions = [];
      data.forEach((address) => {
        newAddressesOptions.push({
          value: address.id,
          label: `${address.address}, ${address.number} - ${address.district}`,
        });
      });
      setOptionsLocal(newAddressesOptions);
    }
  };

  const clearModalFilters = (noSearch) => {
    const listFilterWithoutModal = listFilters.filter(f => f.query !== 'address_id'
      && f.query !== 'hired'
      && f.query !== 'operator_id'
      && f.query !== 'created'
      && f.query !== 'service_id'
      && f.query !== 'quotes'
      && f.query !== 'charged'
      && f.query !== 'rangeDate'
      && f.query !== 'chargedDate'
      && f.query !== 'filterTaskVisit'
      && f.query !== 'hiredDate');

    const listFilterClear = [...listFilterWithoutModal,
      ...[{ query: 'address_id', value: '' },
        { query: 'rangeDate', value: '' },
        { query: 'hiredDate', value: '' },
        { query: 'chargedDate', value: '' },
        { query: 'quotes', value: '' },
        { query: 'charged', value: '' },
        { query: 'hired', value: '' },
        { query: 'service_id', value: '' },
        { query: 'created', value: '' }],
      { query: 'filterTaskVisit', value: '' },
    ];

    setDateFilter([
      {
        startDate: null,
        endDate: null,
        key: 'selection',
      },
    ]);
    setListFilters(listFilterClear);
    if (!noSearch) {
      setFetchFilter(fetchFilter + 1);
    }
  };

  const setTab = (id, offset) => {
    setDateQueryChecked('rangeDate');
    setListFilters(initialState);
    setAdvancedSearch(false);
    setSizeModalApplied(0);
    _getTasksFilter({
      id, // open
      query: `&offset=${offset}`,
      listFilters: [{ query: 'order', value: 'last_created' }],
      offset,
    });
  };

  const changeValueInput = (query) => {
    if (listFilters && listFilters.find(f => f.query === query)) {
      return listFilters.find(f => f.query === query).value;
    }
    return '';
  };

  const optionsStatusTabs = () => {
    if (tabsStatus.length === 4) {
      return [
        {
          id: 1,
          label: 'Pedidos Abertos',
          hexColor: '#3E81F7',
          total: tabsStatus[0].total,
          icon: '',
          setStatus: () => setTab(
            1, // open
            0,
          ),
        },
        {
          id: 2,
          label: 'Pedidos Contratados',
          hexColor: '#59BC5C',
          total: tabsStatus[1].total,
          icon: '',
          setStatus: () => setTab(
            2, // hired
            0,
          ),
        },
        {
          id: 3,
          label: tabsStatus[2].status,
          hexColor: '#EC412A',
          total: tabsStatus[2].total,
          icon: '',
          setStatus: () => setTab(
            3, // charged
            0,
          ),
        },
        {
          id: 4,
          label: 'Pedidos Finalizados',
          hexColor: '#565656',
          total: tabsStatus[3].total,
          icon: statusDone,
          setStatus: () => setTab(
            4, // paid, canceled
            0,
          ),
        },
      ];
    }
    return [];
  };

  const getOptionsSelect = options => options.map((o, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <option key={`${o.value}-option-${index}`} value={o.value}>
      {o.label}
    </option>
  ));

  const getOptionsResponsibility = options => options.map((o, index) => {
    if (index === 0) {
      return (
        <Fragment key={`option-${index}`}>
          <option value="">
            Todos
          </option>
          {o.show_select_responsibility
          && (
            <option key={`${o.responsibility_bucket_id}-option-${index}`} value={o.responsibility_bucket_id}>
              {capitalize(o.company_responsibility)}
            </option>
          )
          }
        </Fragment>
      );
    }
    if (!o.show_select_responsibility) {
      return '';
    }

    return (
      <option key={`${o.responsibility_bucket_id}-option-${index}`} value={o.responsibility_bucket_id}>
        {capitalize(o.company_responsibility)}
      </option>
    );
  });


  const changeFilter = (query, value, noSearch) => {
    if (listFilters.length > 0 && listFilters.find(f => f.query === query)) {
      if (query === 'rangeDate' || query === 'chargedDate' || query === 'hiredDate') {
        const filtersWithoutDate = listFilters.filter(f => f.query !== 'chargedDate' && f.query !== 'rangeDate' && f.query !== 'hiredDate');
        const newListFilters = [...filtersWithoutDate, { query: 'rangeDate', value: '' }, { query: 'hiredDate', value: '' }, { query: 'chargedDate', value: '' }];
        const filters = newListFilters.filter(f => f.query !== query);
        filters.push({ query, value });
        setListFilters(filters);
      } else {
        const filters = listFilters.filter(f => f.query !== query);
        filters.push({ query, value });
        setListFilters(filters);
      }
      if (!noSearch) {
        setFetchFilter(fetchFilter + 1);
      }
    } else if (listFilters.length > 0) {
      const filters = listFilters;
      filters.push({ query, value });
      setListFilters(filters);
      if (!noSearch) {
        setFetchFilter(fetchFilter + 1);
      }
    } else {
      setListFilters([{ query, value }]);
      if (!noSearch) {
        setFetchFilter(fetchFilter + 1);
      }
    }
  };

  useEffect(() => {
    _getTabsStatus();
    _getResponsibilities();
    getServicesAPI();
    getUsersByCompanyAPI();
    getLabelsFilter();
  }, []);

  const setLocalOption = (option) => {
    changeFilter('address_id', option.value, true);
    setLocalTerm(option.label);
  };

  useEffect(() => {
    const searching = setTimeout(() => {
      if (fetchFilter === 0 && location.ofBack && !searchTerm) {
        return;
      }

      changeFilter('term', searchTerm);
    }, 500);
    return () => {
      clearTimeout(searching);
    };
  }, [searchTerm]);

  useEffect(() => {
    const searching = setTimeout(() => {
      getLocalsAPI();
    }, 500);
    return () => {
      clearTimeout(searching);
    };
  }, [localTerm]);

  useEffect(() => {
    if (fetchFilter === 0 && location.ofBack) {
      _getTasksFilter({
        id: statusActived,
        listFilters,
        query: `&offset=${offsetActiveFilter}`,
        offset: offsetActiveFilter,
      });
    } else {
      _getTasksFilter({
        id: statusActived,
        listFilters,
      });
    }
    setSizeFiltersModalApplied();
  }, [fetchFilter]);

  useEffect(() => {
    if (optionsFilters.advancedSearch) {
      const arrayOptions = [];
      arrayOptions.push(optionsFilters.advancedSearch.rangeDate);
      if (optionsFilters.advancedSearch.hiredDate) {
        arrayOptions.push(optionsFilters.advancedSearch.hiredDate);
      }

      if (optionsFilters.advancedSearch.chargedDate) {
        arrayOptions.push(optionsFilters.advancedSearch.chargedDate);
      }
      setOptionsFilterDate(arrayOptions);
    }
  }, [optionsFilters.advancedSearch, statusActived]);

  const changePage = (offset) => {
    _getTasksFilter({
      id: statusActived,
      listFilters,
      query: `&offset=${offset}`,
      offset,
    });
  };

  const changeLocalInput = (value) => {
    setLocalTerm(value);
    if (listFilters && listFilters.find(filter => filter.query === 'address_id')) {
      changeFilter('address_id', '', true); // removing filter when change value local input
    }
  };

  const settingDateFilter = (date, valueRadio) => {
    setDateFilter(date);
    if (date[0].startDate !== null && date[0].endDate !== null) {
      const startDateFormatted = moment(date[0].startDate).format('YYYY-MM-DD HH:mm:ss');
      const endDateFormatted = moment(date[0].endDate).format('YYYY-MM-DD HH:mm:ss');
      changeFilter(valueRadio || dateQueryChecked, `${startDateFormatted},${endDateFormatted}`, true);
    } else {
      changeFilter(valueRadio || dateQueryChecked, '', true);
    }
  };

  const goToDetails = (task) => {
    const { id } = task;
    _setListFiltersRedux({ listFilters, isAdvancedSearch });
    _push(`${routes.taskDetails.replace(':taskId', id)}/orcamentos`);
  };

  const getColorTitleStatus = () => {
    if (statusActived === 1) {
      return '#3E81F7';
    }
    if (statusActived === 2) {
      return '#59BC5C';
    }
    if (statusActived === 3) {
      return '#EC412A';
    }
    if (statusActived === 4) {
      return '#565656';
    }
    return '';
  };

  const searchMoreFilters = () => {
    setAdvancedSearch(!isAdvancedSearch);
    setFetchFilter(fetchFilter + 1);
  };

  const changeRadioDate = (value) => {
    setDateQueryChecked(value);
    settingDateFilter(dateFilter, value);
  };

  const handleFilterLabel = (id) => {
    const labelsFilter = listFilters.find(f => f.query === 'label').value;
    if (labelsFilter && labelsFilter.includes(id)) {
      const labelFiltered = labelsFilter.filter(label => label !== id);
      changeFilter('label', labelFiltered);
    } else {
      changeFilter('label', [...labelsFilter, id]);
    }
  };

  return (
    <Section color="#F5F7F9">
      <Helmet title="Triider - Meus pedidos" />
      <FilterStatusTabs optionsStatus={optionsStatusTabs()} statusActived={statusActived} />
      <Container>
        <FiltersHeader>

          {loadingVisible && !optionsFilters.search
            ? (
              <SkeletonTheme>
                <Skeleton width="75vw" height={65} />
              </SkeletonTheme>
            )
            : (
              <ContentFilters>
                {optionsFilters.search && (
                  <ColumnFilters width={segment_id !== SEGMENTS.IMOBILIARIA && segment_id !== null ? '41.6vw' : '25vw'}>
                    <Label>Pesquisar pedido:</Label>
                    <SearchInput
                      width="100%"
                      id="search"
                      placeholder="Serviço, cliente, código do local...."
                      value={searchTerm}
                      onChange={({ target }) => setSearchTerm(target.value)}
                      type="text"
                      name="term"
                    />
                  </ColumnFilters>
                )}
                {optionsFilters.orderBy && (
                  <ColumnFilters width="16.66vw">
                    <Label>Ordenar por:</Label>
                    <SelectStyled
                      value={changeValueInput('order')}
                      onChange={e => changeFilter('order', e.target.value)}
                    >
                      {getOptionsSelect(optionsFilters.orderBy.options)}
                    </SelectStyled>
                  </ColumnFilters>
                )}
                {IMOB_SEGMENT && optionsFilters.responsibility && (
                  <ColumnFilters width="16.66vw">
                    <Label>Responsabilidades do:</Label>
                    <SelectStyled
                      value={changeValueInput('responsibility_id')}
                      onChange={e => changeFilter('responsibility_id', e.target.value)}
                    >
                      {getOptionsResponsibility(rolesRespFilter)}
                    </SelectStyled>
                  </ColumnFilters>
                )}
                {optionsFilters.advancedSearch && (
                  <ColumnFilters width="16.66vw">
                    <BtnMoreFilters2
                      isLoading={loadingVisible}
                      isOpenAdvanced={isAdvancedSearch}
                      onClick={() => setAdvancedSearch(!isAdvancedSearch)}
                    >
                      {loadingVisible ? <Spinner size="small" />
                        : sizeModalApplied > 0
                          ? (
                            <>
                              Mais
                              <b>
                            &nbsp;
                                {sizeModalApplied}
                            &nbsp;
                              </b>
                              {sizeModalApplied === 1 ? 'filtro' : 'filtros'}
                            </>
                          ) : 'Mais Filtros'}
                    </BtnMoreFilters2>
                  </ColumnFilters>
                )}
              </ContentFilters>
            )
        }
        </FiltersHeader>
        {IMOB_SEGMENT
          && <Labels labelsChecked={listFilters.find(f => f.query === 'label').value} onSelected={id => handleFilterLabel(id)} labels={labels} />
        }
        <ContentPagination>
          <StatusTitleList hexColor={getColorTitleStatus()}>
            {(tabsStatus[statusActived] && tabsStatus[statusActived - 1].status)
                    || 'Finalizados'}
          </StatusTitleList>
          <ShowTasksManaging>
            <Checkbox
              type="checkbox"
              value={changeValueInput('operator_id')}
              checked={changeValueInput('operator_id') === userId}
              onChange={e => changeFilter('operator_id', e.target.value ? '' : userId)}
            />
            <p>
              Apenas os meus pedidos
            </p>
            <NewPagination
              changePage={changePage}
              offset={offsetActiveFilter}
              length={10}
              full={total}
            />
          </ShowTasksManaging>
        </ContentPagination>

        {loadingVisible ? (
          <Loader>
            <SkeletonTheme>
              <Skeleton width="75vw" height={85} count={10} />
            </SkeletonTheme>
          </Loader>
        ) : (
          <Fragment>
            <ListWrapper isOpenAdvancedSearch={isAdvancedSearch}>
              {tasks.length ? (
                <List>
                  {tasks.map(task => (
                    <Row
                      key={`task-${task.id}`}
                      task={task}
                      goToDetails={() => goToDetails(task)}
                    />
                  ))}
                </List>
              ) : (
                <SearchFail>
                  <img src={searchFailIcon} alt="Search Fail Icon" />
                  <h3>PESQUISA SEM RESULTADOS</h3>
                  <p>
                    Sua pesquisa não tem resultados.
                    <br />
                    Altere os filtros ou as palavras-chave e pesquise de novo!
                  </p>
                </SearchFail>
              )}
            </ListWrapper>
          </Fragment>
        )}
      </Container>

      <ModalFilter padding="30px 20px 40px 40px" isOpen={isAdvancedSearch} textTransform="none" title="Mais filtros" textalingheader="left" toggle={() => setAdvancedSearch(!isAdvancedSearch)}>
        {(optionsFilters.advancedSearch
        && (
        <>
          <ContentFilters wrap>
            <ColumnFilters
              onMouseEnter={() => setIsOpenCalendar(true)}
              onMouseLeave={() => setIsOpenCalendar(false)}
              isOpenCalendar={isOpenCalendar}
              width="265px"
            >
              <Label marginTop="10px">Data:</Label>
              {isOpenCalendar
              && optionsFilterDate && (
              <ContentRadio>
                <RadioGroup
                  defaultValue={dateQueryChecked}
                  onChange={(nameTarget, value) => changeRadioDate(value)}
                  options={optionsFilterDate}
                  name="radioDate"
                />
              </ContentRadio>
              )}
              <DateRange
                className="date-range-picker"
                rangeColors={['#FF7700', '#fff']}
                startDatePlaceholder="Início"
                endDatePlaceholder="Fim"
                // onRangeFocusChange={() => verifyIsOpenCalendar()}
                locale={locales.pt}
                dateDisplayFormat="dd/MM/yyyy"
                editableDateInputs
                fixedHeight
                onChange={item => settingDateFilter([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={dateFilter}
              />
            </ColumnFilters>
            {IMOB_SEGMENT && optionsFilters.advancedSearch.address && (
            <ColumnFilters width="265px">
              <Label marginBottom="2px" marginTop="10px">Local:</Label>
              <InputText
                onLoadClosed
                isFormField
                height="40px"
                width="100%"
                borderRadius="4px"
                disabled={loadingVisible}
                key={`filter-${OptionLocal.name}-${OptionLocal.value}`}
                value={localTerm}
                name={OptionLocal.name}
                isAutoComplete
                inputPlaceholder="Buscar..."
                onChange={({ target }) => changeLocalInput(target.value)}
                options={optionsLocal.map(o => ({
                  title: o.label,
                  value: {
                    ...o,
                    key: o.value,
                    value: o.value,
                    label: o.label,
                  },
                }))}
                setOption={setLocalOption}
                autoComplete="off"
              />
            </ColumnFilters>
            )}
            {optionsFilters.advancedSearch.service && (
              <ColumnFilters width="265px">
                <Label marginTop="10px">Tipo de serviço:</Label>
                <SelectStyled
                  value={changeValueInput('service_id')}
                  onChange={e => changeFilter('service_id', e.target.value, true)}
                >
                  {getOptionsSelect(serviceOptions)}
                </SelectStyled>
              </ColumnFilters>
            )}

            <ColumnFilters width="265px">
              <Label marginTop="10px">Operador:</Label>
              <SelectStyled
                value={changeValueInput('operator_id')}
                onChange={e => changeFilter('operator_id', e.target.value, true)}
              >
                {getOptionsSelect(userFilterOptions)}
              </SelectStyled>
            </ColumnFilters>

            {optionsFilters.advancedSearch.created && (
            <ColumnFilters width="265px">
              <Label marginTop="10px">Tempo de abertura:</Label>
              <SelectStyled
                value={changeValueInput('created')}
                onChange={e => changeFilter('created', e.target.value, true)}
              >
                {getOptionsSelect(optionsFilters.advancedSearch.created.options)}
              </SelectStyled>
            </ColumnFilters>
            )}
            {optionsFilters.advancedSearch.hired && (
            <ColumnFilters width="265px">
              <Label marginTop="10px">Tempo de contratação:</Label>
              <SelectStyled
                value={changeValueInput('hired')}
                onChange={e => changeFilter('hired', e.target.value, true)}
              >
                {getOptionsSelect(optionsFilters.advancedSearch.hired.options)}
              </SelectStyled>
            </ColumnFilters>
            )}
            {optionsFilters.advancedSearch.charged && (
            <ColumnFilters width="265px">
              <Label marginTop="10px">Tempo de pagamento em aberto:</Label>
              <SelectStyled
                value={changeValueInput('charged')}
                onChange={e => changeFilter('charged', e.target.value, true)}
              >
                {getOptionsSelect(optionsFilters.advancedSearch.charged.options)}
              </SelectStyled>
            </ColumnFilters>
            )}
            {optionsFilters.advancedSearch.quotes && (
            <ColumnFilters width="265px">
              <Label marginTop="10px">Número de orçamentos:</Label>
              <SelectStyled
                value={changeValueInput('quotes')}
                onChange={e => changeFilter('quotes', e.target.value, true)}
              >
                {getOptionsSelect(optionsFilters.advancedSearch.quotes.options)}
              </SelectStyled>
            </ColumnFilters>
            )}
            {IMOB_SEGMENT && optionsFilters.advancedSearch.filterTaskVisit && (
            <ColumnFilters width="265px">
              <Label marginTop="10px">Status de visita:</Label>
              <SelectStyled
                value={changeValueInput('filterTaskVisit')}
                onChange={e => changeFilter('filterTaskVisit', e.target.value, true)}
              >
                {getOptionsSelect(optionsFilters.advancedSearch.filterTaskVisit.options)}
              </SelectStyled>
            </ColumnFilters>
            )}
          </ContentFilters>
          <ContentFooterButtons>
            <ButtonFooter type="button" onClick={() => clearModalFilters(true)}>
              Limpar filtros
            </ButtonFooter>
            <ButtonFooter type="button" colorBorder="#F07E31" colorBackground="#F07E31" colorFont="#fff" onClick={searchMoreFilters}>
              Buscar
            </ButtonFooter>
          </ContentFooterButtons>
        </>
        )
        )}
      </ModalFilter>
    </Section>
  );
};

const mapStateToProps = state => ({
  tasks: state.task.tasks,
  total: state.task.total,
  offsetActiveFilter: state.task.activeFilters.find(f => f.name === 'offset').value,
  userId: state.auth.triiderUser.user.id,
  activeFiltersState: state.task.activeFilters,
  tabsStatus: state.task.tabsStatus,
  rolesRespFilter: state.companyResponsibility.roles,
  statusActived: state.task.statusFilterActived.id,
  loadingVisible: state.ui.loaders.includes('TASK_LIST'),
  company_id: state.auth.triiderUser.company.id,
  segment_id: state.auth.triiderUser.company.segment_id,
  optionsFilters: state.task.optionsFilters,
  _listFiltersRedux: state.task.listFilters,
  _isAdvancedSearchRedux: state.task.isAdvancedSearch,
});

const mapDispatchToProps = {
  _setListFiltersRedux: TaskCreators.setListFilters,
  _getTasks: TaskCreators.getTasksRequest,
  _getFilters: TaskCreators.getTasksFiltersRequest,
  _setActiveFilters: TaskCreators.setActiveFilters,
  _getTabsStatus: TaskCreators.getTabsStatusRequest,
  _getTasksFilter: TaskCreators.getTasksFilter,
  _getResponsibilities: RespCreators.getResponsibilitiesRequest,
  _push: push,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskList);
